import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "redux/ApiService/ApiService";
import Sessions from "utils/Sessions";

export const listDprKpis = createAsyncThunk(
  "dpr-kpi/list",
  async ({ projectId, includeInactive = false }) => {
    const params = new URLSearchParams();
    if (projectId) params.append("projectId", projectId);
    if (includeInactive) params.append("includeInactive", "true");

    const res = await ApiService.get(
      `admin/dpr-kpis${params.toString() ? `?${params.toString()}` : ""}`,
      {
        headers: { Authorization: `Bearer ${Sessions.userToken}` },
      }
    )
      .then((r) => r)
      .catch((error) => error.response);
    return res;
  }
);

export const createDprKpi = createAsyncThunk("dpr-kpi/create", async (body) => {
  const res = await ApiService.post(
    "admin/dpr-kpis",
    { ...body, projectId: body.projectId }, // Ensure projectId is included
    { headers: { Authorization: `Bearer ${Sessions.userToken}` } }
  )
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const updateDprKpi = createAsyncThunk("dpr-kpi/update", async ({ id, body }) => {
  const res = await ApiService.put(
    `admin/dpr-kpis/${id}`,
    { ...body },
    { headers: { Authorization: `Bearer ${Sessions.userToken}` } }
  )
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const updateDprKpiStatus = createAsyncThunk(
  "dpr-kpi/update-status",
  async ({ id, isActive }) => {
    const res = await ApiService.patch(
      `admin/dpr-kpis/${id}/status`,
      { isActive },
      { headers: { Authorization: `Bearer ${Sessions.userToken}` } }
    )
      .then((r) => r)
      .catch((error) => error.response);
    return res;
  }
);

export const deleteDprKpi = createAsyncThunk("dpr-kpi/delete", async (id) => {
  const res = await ApiService.delete(`admin/dpr-kpis/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});
